import { render } from "./JobDetails.vue?vue&type=template&id=985798aa&scoped=true&lang=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=985798aa&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985798aa"]])

export default __exports__